import { SplideSlide, SplideTrack } from '@splidejs/react-splide';

import Slider from '../UI/Slider';
import classes from './statistic-block.module.scss';
import { StatisticBlockProps } from './StatisticBlock.type';

function StatisticBlock({
  statisticBlockCards,
  statisticBlockShow,
  statisticBlockTitle,
  isColored = true,
}: StatisticBlockProps) {
  return statisticBlockShow ? (
    <div className={classes.container}>
      {statisticBlockCards && (
        <Slider title={statisticBlockTitle} isColored={isColored}>
          <SplideTrack>
            {statisticBlockCards.map((card) => (
              <SplideSlide key={card.title}>
                <div className={classes.card}>
                  <h3 className={classes.title}>{card.title}</h3>
                  <p>{card.subtitle}</p>
                </div>
              </SplideSlide>
            ))}
          </SplideTrack>
        </Slider>
      )}
    </div>
  ) : null;
}

export default StatisticBlock;
